export interface FileItem {
  key: string;
  size: number;
  uploaded: string;
  httpMetadata: { contentType: string };
  customMetadata?: { thumbnail?: string };
}
export interface TransferTask {
  type: "upload" | "download";
  name: string;
  file?: File;
  remoteKey: string;
  loaded: number;
  total: number;
  status: "pending" | "in-progress" | "completed" | "failed";
  error?: any;
}
export function encodeKey(key: string) {
  return key.split("/").map(encodeURIComponent).join("/");
}
export function isDirectory(file: FileItem) {
  return file.httpMetadata?.contentType === "application/x-directory";
}
export function baseName(key: string) {
  return key.replace(/\/$/, "").split("/").pop() || "";
}
